module.exports = __webpack_public_path__ + "static/face-effects-icon-6947eb154733b00dac0f8379db138f4b.svg";